import React from 'react';
import { FaFacebookF, FaXTwitter, FaYoutube, FaInstagram } from 'react-icons/fa6';
import { SOCIAL } from '../../utils/constants';

const icons = [
  { Icon: FaFacebookF, url: SOCIAL.facebook, bg: '#1877F2', cls: 'sf-fb', radius: '0 8px 0 0' },
  { Icon: FaXTwitter, url: SOCIAL.twitter, bg: '#000', cls: 'sf-tw', radius: '0' },
  { Icon: FaYoutube, url: SOCIAL.youtube, bg: '#FF0000', cls: 'sf-yt', radius: '0' },
  { Icon: FaInstagram, url: SOCIAL.instagram, bg: 'linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)', cls: 'sf-ig', radius: '0 0 8px 0' },
];

export function FloatingSocial() {
  return (
    <div style={{ position: 'fixed', left: 0, top: '50%', transform: 'translateY(-50%)', zIndex: 90, display: 'flex', flexDirection: 'column', gap: 2 }}>
      {icons.map(({ Icon, url, bg, radius }, i) => (
        <a key={i} href={url} target="_blank" rel="noopener noreferrer" style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center', width: 44, height: 44,
          color: 'white', background: bg, borderRadius: radius, transition: 'all .25s',
        }}>
          <Icon size={18} />
        </a>
      ))}
    </div>
  );
}

export function SocialBar({ dark }) {
  const style = dark
    ? { background: 'rgba(255,255,255,.08)', color: 'rgba(255,255,255,.6)' }
    : { background: 'var(--soft-orange)', color: 'var(--brown)' };
  return (
    <div style={{ display: 'flex', gap: 10 }}>
      {icons.map(({ Icon, url }, i) => (
        <a key={i} href={url} target="_blank" rel="noopener noreferrer" style={{
          width: 38, height: 38, borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center',
          transition: 'all .25s', ...style,
        }}>
          <Icon size={16} />
        </a>
      ))}
    </div>
  );
}
